'use strict';

wbApp.factory('messageTemplateSvc', ['$resource', '$http', '$q', '$translate', 'notificationSvc', 'repositorySvc',
    function ($resource, $http, $q, $translate, notificationSvc, repositorySvc) {

        var MessageTemplate = $resource('/restapi/custom-email-message-templates/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/custom-email-message-templates/:id' },
            'getAllInfo': { method: 'GET', isArray: true, url: '/restapi/custom-email-message-templates/info' },
            'insert': { method: 'POST', url: '/restapi/custom-email-message-templates' },
            'update': { method: 'PUT', url: '/restapi/custom-email-message-templates/:id' },
            'delete': { method: 'DELETE', url: '/restapi/custom-email-message-templates/:id' },
        });

        function createNew() {
            var model = {
                id: null,
                recipients: [],
                name: null,
                subject: null,
                messageBody: null
            };

            return model;
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                MessageTemplate,
                model);
        }

        function remove(templateId) {
            return repositorySvc.customDelete(
                'delete',
                MessageTemplate,
                { id: templateId });
        }

        function update(model) {
            return repositorySvc.customPutWithParams(
                'update',
                MessageTemplate,
                { id: model.id },
                model);
        }

        function getById(templateId) {
            return repositorySvc.customGet('getById', MessageTemplate, { id: templateId });
        }

        function getAllInfo() {
            return repositorySvc.customGet('getAllInfo', MessageTemplate, {});
        }

        return {
            createNew: createNew,
            getById: getById,
            getAllInfo: getAllInfo,
            insert: insert,
            remove: remove,
            update: update,
        };
    }
]);